const WRAP_PADDING = 8;
const BOX_SHADOW =
  "rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset";
const MIN_HEADER_WIDTH = 200;
export default function(Vue) {
  const tag = "[dialogDrag]";
  let mo;
  let handleTouchStart = (e) => {
    // console.log(tag, e.target);
    if (
      e.target.classList.contains("el-dialog__header") ||
      e.target.classList.contains("el-dialog__title") ||
      e.target.classList.contains("el-dialog__footer") ||
      e.target.classList.contains("dialog-footer")
    ) {
      // console.log(tag, "handleTouchStart preventDefault");
      e.preventDefault();
      e.stopPropagation();
      moveFn.start(e.target, e);
      return false;
    }
  };

  let handleTouchEnd = (e) => {
    if (
      e.target.classList.contains("el-dialog__header") ||
      e.target.classList.contains("el-dialog__title") ||
      e.target.classList.contains("el-dialog__footer") ||
      e.target.classList.contains("dialog-footer")
    ) {
      // console.log(tag, "handleTouchEnd preventDefault");
      e.preventDefault();
      e.stopPropagation();
      moveFn.end(e.target);
      return false;
    }
  };
  let moveFn = (() => {
    let disX, disY, styL, styT;
    let dragWarpDom;

    function start(target, e) {
      dragWarpDom = target.closest(".el-dialog__wrapper");
      target.addEventListener("touchmove", move);

      let touches = e.changedTouches;
      if (touches.length) {
        disX = touches[0].pageX;
        disY = touches[0].pageY;
        // 获取到的值带 px 正则匹配替换

        styL = +dragWarpDom.style.left.replace(/\px/g, "");
        styT = +dragWarpDom.style.top.replace(/\px/g, "");
      }
    }
    function move(e) {
      let touches = e.changedTouches;
      if (touches.length && dragWarpDom) {
        // 通过事件委托，计算移动的距离
        let l = touches[0].pageX - disX;
        let t = touches[0].pageY - disY;

        //移动当前元素;
        dragWarpDom.style.left = `${l + styL}px`;
        dragWarpDom.style.top = `${t + styT}px`;
      }
    }
    function end(target) {
      target.removeEventListener("touchmove", move);
    }
    return {
      start,
      end,
    };
  })();

  let dragFn = (e) => {
    const disX = e.clientX;
    const disY = e.clientY;
    // 获取到的值带 px 正则匹配替换
    let styL, styT;
    const dragWarpDom = e.target.closest(".el-dialog__wrapper");
    styL = +dragWarpDom.style.left.replace(/\px/g, "");
    styT = +dragWarpDom.style.top.replace(/\px/g, "");

    document.onmousemove = function(e) {
      // 通过事件委托，计算移动的距离
      let l = e.clientX - disX;
      let t = e.clientY - disY;
      // 移动当前元素
      dragWarpDom.style.left = `${l + styL}px`;
      dragWarpDom.style.top = `${t + styT}px`;
    };

    document.onmouseup = function(e) {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };

  function isIOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  return {
    inserted(el, binding) {
      if (!binding.value || !binding.value.draggable) {
        return;
      }
      // console.log(tag, "#inserted");
      const w = parseInt(document.documentElement.clientWidth);
      const h = parseInt(document.documentElement.clientHeight);

      const dialogHeaderEl = el.querySelector(".el-dialog__header");
      dialogHeaderEl.style.cursor = "move";
      const dialogFooterEl = el.querySelector(".el-dialog__footer");
      dialogFooterEl.style.cursor = "move";

      const dragDom = el.querySelector(".el-dialog");
      dragDom.style["box-shadow"] = BOX_SHADOW;

      Vue.nextTick(function() {
        // DOM updated
        // console.log(tag, "#DOM updated");
        const dragDom = el.querySelector(".el-dialog");
        const dialogHeaderEl = el.querySelector(".el-dialog__header");
        const dialogFooterEl = el.querySelector(".el-dialog__footer");
        if (dragDom) {
          const dragWarpDom = dragDom.closest(".el-dialog__wrapper");
          if (dragWarpDom && dragDom.offsetHeight & dragDom.offsetWidth) {
            // console.log(
            //   `#set dialogWrapper size:${dragDom.offsetHeight},${dragDom.offsetWidth}`
            // );

            if (binding.value.bodyHeight) {
              dragWarpDom.style.height = `calc( ${dialogHeaderEl.offsetHeight}px +  ${binding.value.bodyHeight} + ${dialogFooterEl.offsetHeight}px + ${WRAP_PADDING}px )`;
            } else {
              dragWarpDom.style.height = `${dragDom.offsetHeight +
                WRAP_PADDING}px`;
            }
            if (binding.value.width) {
              dragWarpDom.style.width = `calc( ${binding.value.width} + ${WRAP_PADDING}px )`;
            } else {
              dragWarpDom.style.width = `${dragDom.offsetWidth +
                WRAP_PADDING}px`;
            }
            dragWarpDom.style.right = "auto";
          }
        }
      });

      //產生縮小視窗按鈕
      const scaleBtnDom = document.createElement("button");
      scaleBtnDom.classList.add("el-dialog__headerbtn");
      scaleBtnDom.style.right = "50px";

      //產生縮小符號
      let downloadIconDom = document.createElement("i");
      downloadIconDom.classList.add("el-icon");
      downloadIconDom.classList.add("el-icon-download");
      scaleBtnDom.appendChild(downloadIconDom);

      //產生放大符號
      let uploadIconDom = document.createElement("i");
      uploadIconDom.classList.add("el-icon");
      uploadIconDom.classList.add("el-icon-upload2");
      // scaleBtnDom.appendChild(uploadIconDom);

      scaleBtnDom.addEventListener("click", function(e) {
        e.stopPropagation();
        const dragWarpDom = dragDom.closest(".el-dialog__wrapper");
        if (!dragWarpDom.classList.contains("minimum")) {
          // console.log(tag, "#push minimum");
          dragWarpDom.classList.add("minimum");
        } else {
          // console.log(tag, "#remove minimum");
          dragWarpDom.classList.remove("minimum");
        }
      });
      dialogHeaderEl.appendChild(scaleBtnDom);

      //監聽minimum class的存在與否判斷最小化操作視窗
      let dragOffsetWidth;
      // let dragOffsetHeight;
      let dragWarpHeight;
      let dragWarpStyleHeight;
      let dragWarpStyleWidth;

      if (mo) {
        mo.disconnect();
        mo = null;
      }
      mo = new MutationObserver((mutations) => {
        const dialogBodyEl = el.querySelector(".el-dialog__body");
        const dialogFooterEl = el.querySelector(".el-dialog__footer");
        const dragWarpDom = dragDom.closest(".el-dialog__wrapper");
        mutations.forEach(function(mutation) {
          // console.log("#mutations:" + mutation.attributeName);
          if (mutation.attributeName === "class") {
            if (dragWarpDom.classList.contains("minimum")) {
              // scale in

              dragOffsetWidth = dragDom.offsetWidth;
              // dragOffsetHeight = dragDom.offsetHeight;

              dragWarpHeight = dragWarpDom.style.height;
              // dragWarpOffsetHeight = dragWarpDom.offsetHeight;
              // dragWarpOffsetWidth = dragWarpDom.offsetWidth;
              dragWarpStyleHeight = dragWarpDom.style.height;
              dragWarpStyleWidth = dragWarpDom.style.width;

              //隱藏body&footer
              dialogBodyEl.style.display = "none";
              dialogFooterEl.style.display = "none";

              //變更寬高
              dragDom.style.width = `${MIN_HEADER_WIDTH}px`;
              dragWarpDom.style.height = `${dragDom.offsetHeight +
                WRAP_PADDING}px`;
              dragWarpDom.style.width = `${MIN_HEADER_WIDTH + WRAP_PADDING}px`;

              //移動到底部置中
              dragWarpDom.style.position = "fixed";
              dragWarpDom.style.left = `${(parseInt(w) -
                MIN_HEADER_WIDTH -
                WRAP_PADDING) /
                2}px`;
              dragWarpDom.style.top = `${parseInt(h) -
                parseInt(dragDom.offsetHeight) -
                WRAP_PADDING}px`;

              //變更樣式
              dialogHeaderEl.style.cursor = "pointer";
              dialogHeaderEl.style.background = "#c6e2ff";
              if (isIOS()) {
                scaleBtnDom.innerHTML = "";
                scaleBtnDom.appendChild(uploadIconDom);
              } else {
                scaleBtnDom.replaceChildren(uploadIconDom);
              }
            } else {
              // scale out

              //顯示body & footer
              dialogBodyEl.style.display = "block";
              dialogFooterEl.style.display = "block";

              //還原原始大小
              dragDom.style.width = `${dragOffsetWidth}px`;
              // dragWarpDom.style.height = `${dragWarpOffsetHeight}px`;
              // dragWarpDom.style.width = `${dragWarpOffsetWidth}px`;
              dragWarpDom.style.height = dragWarpStyleHeight;
              dragWarpDom.style.width = dragWarpStyleWidth;

              //顯示於螢幕置中處
              dragWarpDom.style.position = "";
              dragWarpDom.style.right = "auto";
              dragWarpDom.style.left = `${(w -
                parseInt(dragWarpDom.offsetWidth)) /
                2}px`;
              dragWarpDom.style.top = `${(h -
                parseInt(dragWarpDom.offsetHeight)) /
                2}px`;

              dialogHeaderEl.style.cursor = "move";
              dialogHeaderEl.style.background = "#FFF";

              if (isIOS()) {
                scaleBtnDom.innerHTML = "";
                scaleBtnDom.appendChild(downloadIconDom);
              } else {
                scaleBtnDom.replaceChildren(downloadIconDom);
              }
            }
          }
        });
      });
      mo.observe(dragDom.closest(".el-dialog__wrapper"), {
        attributes: true,
        childList: false,
        characterData: false,
      });

      dialogHeaderEl.onmousedown = (e) => {
        dragFn(e);
      };
      dialogFooterEl.onmousedown = (e) => {
        dragFn(e);
      };

      if (isIOS()) {
        document.body.addEventListener("touchstart", handleTouchStart, {
          passive: false,
        });
        document.body.addEventListener("touchend", handleTouchEnd, {
          passive: false,
        });
      }
    },
    unbind: () => {
      // console.log(tag, "#unbind");
      if (isIOS()) {
        document.body.removeEventListener("touchstart", handleTouchStart, {
          passive: false,
        });
        document.body.removeEventListener("touchend", handleTouchEnd, {
          passive: false,
        });
      }
    },
  };
}
